import { BOARD_SIZE } from "../config"

const getTop = (count: number, hp: number): any[] => {
    const items: any[] = []
    Array(count * 2).fill(null).forEach((item, index) => {
        if ((index + 2) % 2 === 0) {
            items.push({ health: hp, posX: 0, posY: index + 2, freeze: 0 })
        }
    })
    return items
}

const getBottom = (count: number, hp: number): any[] => {
    const items: any[] = []
    Array(count * 2).fill(null).forEach((item, index) => {
        if ((index + 2) % 2 === 0) {
            items.push({ health: hp, posX: BOARD_SIZE - 1, posY: index + 2, freeze: 0 })
        }
    })
    return items
}

const getRight = (count: number, hp: number): any[] => {
    const items: any[] = []
    Array(count * 2).fill(null).forEach((item, index) => {
        if ((index + 2) % 2 === 0) {
            items.push({ health: hp, posX: index + 2, posY: BOARD_SIZE - 1, freeze: 0 })
        }
    })
    return items
}

const getLeft = (count: number, hp: number): any[] => {
    const items: any[] = []
    Array(count * 2).fill(null).forEach((item, index) => {
        if ((index + 2) % 2 === 0) {
            items.push({ health: hp, posX: index + 2, posY: 0, freeze: 0 })
        }
    })
    return items
}


export const levels = {
    // level 1
    '5': getTop(8, 650),
    '6': getTop(8, 650),
    '7': getTop(8, 650),
    '15': getTop(8, 650),
    '30': getTop(8, 650),
    '33': getTop(8, 650),
    '36': getTop(8, 650),
    '39': getTop(8, 650),
    // level 2
    '65': getTop(10, 650),
    '68': getTop(10, 650),
    '51': getTop(10, 650),
    '54': getTop(10, 650),
    '57': getBottom(10, 650),
    '60': getBottom(10, 650),
    '63': getBottom(10, 650),
    '66': getBottom(10, 650),

    // new
    '69': getBottom(10, 650),
    '72': getBottom(10, 650),
    '75': getBottom(10, 650),
    '78': getBottom(10, 650),

    // level 3
    '145': getTop(10, 650),
    '146': getTop(10, 650),
    '147': getTop(10, 650),
    '149': getBottom(10, 650),
    '150': getBottom(10, 650),
    '151': getBottom(10, 650),
    '153': getLeft(10, 650),
    '154': getLeft(10, 650),
    '155': getLeft(10, 650),

    // new
    '160': getTop(10, 15),
    '165': getTop(10, 15),
    '170': getTop(10, 15),
    '175': getBottom(10, 15),
    '180': getBottom(10, 15),
    '185': getBottom(10, 15),

    // level 4
    '200': getTop(12, 650),
    '201': getTop(12, 650),
    '202': getTop(12, 650),
    '203': getTop(12, 650),
    '204': getTop(12, 650),
    '206': getBottom(12, 650),
    '207': getBottom(12, 650),
    '208': getBottom(12, 650),
    '209': getBottom(12, 650),
    '210': getBottom(12, 650),
    '212': getLeft(12, 650),
    '213': getLeft(12, 650),
    '214': getLeft(12, 650),
    '215': getLeft(12, 650),
    '216': getLeft(12, 650),

    // new
    '235': getTop(10, 15),
    '240': getTop(10, 15),
    '245': getTop(10, 15),
    '250': getBottom(10, 15),
    '255': getBottom(10, 15),
    '260': getBottom(10, 15),
    '265': getRight(10, 15),

    // level 5
    '270': getTop(12, 850),
    '271': getTop(12, 850),
    '272': getTop(12, 850),
    '273': getTop(12, 850),
    '274': getTop(12, 850),
    '275': getBottom(12, 850),
    '276': getBottom(12, 850),
    '277': getBottom(12, 850),
    '278': getBottom(12, 850),
    '279': getBottom(12, 850),
    '280': getLeft(12, 850),
    '281': getLeft(12, 850),
    '282': getLeft(12, 850),
    '283': getLeft(12, 850),
    '284': getLeft(12, 850),
    // level 6
    '320': getTop(12, 1050),
    '321': getTop(12, 1050),
    '322': getTop(12, 1050),
    '323': getTop(12, 1050),
    '324': getTop(12, 1050),
    '325': getBottom(12, 1050),
    '326': getBottom(12, 1050),
    '327': getBottom(12, 1050),
    '328': getBottom(12, 1050),
    '329': getBottom(12, 1050),
    '330': getLeft(12, 1050),
    '331': getLeft(12, 1050),
    '332': getLeft(12, 1050),
    '333': getLeft(12, 1050),
    '334': getLeft(12, 1050),
    // level7
    '335': getTop(12, 1050),
    '336': getTop(12, 1050),
    '337': getTop(12, 1050),
    '338': getTop(12, 1050),
    '339': getTop(12, 1050),
    '340': getBottom(12, 1050),
    '341': getBottom(12, 1050),
    '342': getBottom(12, 1050),
    '343': getBottom(12, 1050),
    '344': getBottom(12, 1050),
    '345': getLeft(12, 1050),
    '346': getLeft(12, 1050),
    '347': getLeft(12, 1050),
    '348': getLeft(12, 1050),
    '349': getLeft(12, 1050),

    // new
    '350': getTop(12, 400),
    '351': getTop(12, 400),
    '352': getTop(12, 400),
    '353': getTop(12, 400),
    '354': getTop(12, 400),
    '355': getBottom(12, 400),
    '356': getBottom(12, 400),
    '357': getBottom(12, 400),
    '358': getBottom(12, 400),
    '359': getBottom(12, 400),
    '360': getLeft(12, 400),
    '361': getLeft(12, 400),
    '362': getLeft(12, 400),
    '363': getLeft(12, 400),
    '364': getLeft(12, 400),

    '415': getRight(14, 1050),
    '416': getTop(14, 1050),
    '417': getTop(14, 1050),
    '418': getTop(14, 1050),
    '419': getTop(14, 1050),
    '420': getTop(14, 1050),
    '421': getTop(14, 1050),
    '422': getTop(14, 1050),
    '423': getTop(14, 1050),
    '424': getRight(14, 1050),
    '425': getRight(14, 1050),
    '426': getRight(14, 1050),
    '427': getRight(14, 1050),
    '428': getRight(14, 1050),
    '429': getRight(14, 1050),
    '430': getRight(14, 1050),
    '431': getRight(14, 1050),
    '432': getRight(14, 1050),
    '433': getRight(14, 1050),
    '434': getLeft(14, 1050),
    '435': getLeft(14, 1050),
    '436': getLeft(14, 1050),
    '437': getLeft(14, 1050),
    '438': getLeft(14, 1050),
    '439': getLeft(14, 1050),
    '440': getBottom(14, 1050),
    '441': getBottom(14, 1050),
    '442': getBottom(14, 1050),
    '443': getBottom(14, 1050),
    '444': getBottom(14, 1050),
    '445': getBottom(14, 1050),
    '446': getTop(14, 1050),
    '447': getTop(14, 1050),
    '448': getTop(14, 1050),
    '449': getTop(14, 1050),
    '450': getTop(14, 1050),
    '451': getTop(14, 1050),
    '452': getTop(14, 1050),
    '453': getTop(14, 1050),
    '454': getRight(14, 1050),
    '455': getRight(14, 1050),
    '456': getRight(14, 1050),
    '457': getRight(14, 1050),
    '458': getRight(14, 1050),
    '459': getRight(14, 1050),
    '460': getRight(14, 1050),
    '461': getRight(14, 1050),
    '462': getRight(14, 1050),
    '463': getRight(14, 1050),
    '464': getLeft(14, 1050),
    '465': getLeft(14, 1050),
    '466': getLeft(14, 1050),
    '467': getLeft(14, 1050),
    '468': getLeft(14, 1050),
    '469': getLeft(14, 1050),
    '470': getBottom(14, 1050),
    '471': getBottom(14, 1050),
    '472': getBottom(14, 1050),
    '473': getBottom(14, 1050),
    '474': getBottom(14, 1050),
    '475': getBottom(14, 1050),
    // level8
    '500': getRight(14, 3580),
    '501': getTop(14, 3580),
    '502': getTop(14, 3580),
    '503': getTop(14, 3580),
    '504': getTop(14, 3580),
    '505': getTop(14, 3580),
    '506': getTop(14, 3580),
    '507': getTop(14, 3580),
    '508': getTop(14, 3580),
    '509': getRight(14, 3580),
    '510': getRight(14, 3580),
    '511': getRight(14, 3580),
    '512': getRight(14, 3580),
    '513': getRight(14, 3580),
    '514': getRight(14, 3580),
    '515': getRight(14, 3580),
    '516': getRight(14, 3580),
    '517': getRight(14, 3580),
    '518': getRight(14, 3580),
    '519': getLeft(14, 3580),
    '520': getLeft(14, 3580),
    '521': getLeft(14, 3580),
    '522': getLeft(14, 3580),
    '523': getLeft(14, 3580),
    '524': getLeft(14, 3580),
    '525': getBottom(14, 3580),
    '526': getBottom(14, 3580),
    '527': getBottom(14, 3580),
    '528': getBottom(14, 3580),
    '529': getBottom(14, 3580),
    '530': getBottom(14, 3580),
    '531': getTop(14, 3580),
    '532': getTop(14, 3580),
    '533': getTop(14, 3580),
    '534': getTop(14, 3580),
    '535': getTop(14, 3580),
    '536': getTop(14, 3580),
    '537': getTop(14, 3580),
    '538': getTop(14, 3580),
    '539': getRight(14, 3580),
    '540': getRight(14, 3580),
    '541': getRight(14, 3580),
    '542': getRight(14, 3580),
    '543': getRight(14, 3580),
    '544': getRight(14, 3580),
    '545': getRight(14, 3580),
    '546': getRight(14, 3580),
    '547': getRight(14, 3580),
    '548': getRight(14, 3580),
    '549': getLeft(14, 3580),
    '550': getLeft(14, 3580),
    '551': getLeft(14, 3580),
    '552': getLeft(14, 3580),
    '553': getLeft(14, 3580),
    '554': getLeft(14, 3580),
    '555': getBottom(14, 3580),
    '556': getBottom(14, 3580),
    '557': getBottom(14, 3580),
    '558': getBottom(14, 3580),
    '559': getBottom(14, 3580),
    '560': getBottom(14, 3580),
    '561': getTop(14, 3580),
    '562': getTop(14, 3580),
    '563': getTop(14, 3580),
    '564': getTop(14, 3580),
    '565': getTop(14, 3580),
    '566': getTop(14, 3580),
    '567': getTop(14, 3580),
    '568': getTop(14, 3580),
    '569': getRight(14, 3580),
    '570': getRight(14, 3580),
    '580': getRight(14, 3580),
    '581': getRight(14, 3580),
    '582': getRight(14, 3580),
    '583': getRight(14, 3580),
    '584': getRight(14, 3580),
    '585': getRight(14, 3580),
    '586': getRight(14, 3580),
    '587': getRight(14, 3580),
    '588': getLeft(14, 3580),
    '589': getLeft(14, 3580),
    '590': getLeft(14, 3580),
    '591': getLeft(14, 3580),
    '592': getLeft(14, 3580),
    '593': getLeft(14, 3580),
    '594': getBottom(14, 3580),
    '595': getBottom(14, 3580),
    '596': getBottom(14, 3580),
    '597': getBottom(14, 3580),
    '598': getBottom(14, 3580),
    '599': getBottom(14, 3580),
    '600': getTop(14, 3580),
    '601': getTop(14, 3580),
    '602': getTop(14, 3580),
    '603': getTop(14, 3580),
    '604': getTop(14, 3580),
    '605': getTop(14, 3580),
    '606': getTop(14, 3580),
    '607': getTop(14, 3580),
    '608': getRight(14, 3580),
    '609': getRight(14, 3580),
    '610': getRight(14, 3580),
    '611': getRight(14, 3580),
    '612': getRight(14, 3580),
    '613': getRight(14, 3580),
    '614': getRight(14, 3580),
    '615': getRight(14, 3580),
    '616': getRight(14, 3580),
    '617': getRight(14, 3580),
    '618': getLeft(14, 3580),
    '619': getLeft(14, 3580),
    '620': getLeft(14, 3580),
    '621': getLeft(14, 3580),
    '622': getLeft(14, 3580),
    '623': getLeft(14, 3580),
    '624': getBottom(14, 3580),
    '625': getBottom(14, 3580),
    '626': getBottom(14, 3580),
    '627': getBottom(14, 3580),
    '628': getBottom(14, 3580),
    '629': getBottom(14, 3580),
}